import * as THREE from "three";

// Radial chromatic aberration: each color channel is sampled at a UV
// offset proportional to its distance from `center`, scaled by `strength`.
// Designed for `ShaderPass(ChromaticAberrationShader)` from
// three/examples/jsm/postprocessing/ShaderPass.
export const ChromaticAberrationShader = {
  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    strength: { value: 0.0 },
    center: { value: new THREE.Vector2(0.5, 0.5) },
  },
  vertexShader: /* glsl */ `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform float strength;
    uniform vec2 center;
    varying vec2 vUv;
    void main() {
      vec2 d = vUv - center;
      // Quadratic falloff so the centre stays clean and the edges shimmer.
      vec2 offset = d * strength * (0.5 + dot(d, d));
      float r = texture2D(tDiffuse, vUv + offset).r;
      float g = texture2D(tDiffuse, vUv).g;
      float b = texture2D(tDiffuse, vUv - offset).b;
      float a = texture2D(tDiffuse, vUv).a;
      gl_FragColor = vec4(r, g, b, a);
    }
  `,
};
